import * as React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { CheckoutOrderFragment, InfoMessagePositionsEnum, InfoMessagesFragment } from '@websky/graphql';
import { GdsAggregationServiceGroup } from '../../../../types';
import { useTheme } from '../../../../../theme';
import { getOrder } from '../../../../store/order/selectors';
import InfoMessages from '../../../../../InfoMessages';
import ServicesFactory from '../Services/ServicesFactory';

interface Props {
	segmentId: string;
	services: GdsAggregationServiceGroup[];
	title: string;
	messages?: InfoMessagesFragment[];
	hideSelected?: boolean;
}

const ServicesCardsList: React.FC<Props> = ({ segmentId, services, title, messages, hideSelected = true }) => {
	const order: CheckoutOrderFragment = useSelector(getOrder);

	const theme = useTheme('ServiceAggregation').ServiceAggregation,
		cardsListTheme = useTheme('Checkout').ServicesCardsList;

	const hideBlock = useMemo(() => {
		if (!services.length) {
			return true;
		}

		if (hideSelected) {
			return services.every(service => service.selectedServices.length > 0);
		}

		return false;
	}, [services, hideSelected]);

	return (
		<div className={cn(theme.container, { [cardsListTheme.hidden]: hideBlock })}>
			<div className={theme.header}>{title}</div>

			<div className={cardsListTheme.services}>
				{services.map(service => (
					<ServicesFactory
						key={service.type}
						service={service}
						segmentId={segmentId}
						hideCard={hideSelected && service.selectedServices.length > 0}
					/>
				))}

				{!!messages?.length && (
					<InfoMessages
						renderMessagesWithoutWrapper={true}
						htmlClassName={cardsListTheme.bookingAncillaries__root}
						itemHtmlClassName={cardsListTheme.bookingAncillaries__item}
						position={InfoMessagePositionsEnum.bookingAncillaries}
						messages={order.messages}
					/>
				)}
			</div>
		</div>
	);
};

export default ServicesCardsList;
